<template>
    <div class="GalleryPage" :class="{ slideshowActive: slideshowActive }">
		<div class="GalleryPage__header">
			<h2>{{ $t('GalleryHeader')}}</h2>
		</div>
		<div class="GalleryPage__cards">
			<GalleryCard 
				v-for="(category, index) in gallery"
				:key="index"
				:title="category.title"
				:folderName="category.folderName"
				:images="category.images"
				:setSlideshow="setSlideshow"
			/>
		</div>
		<Slideshow 
			:images="images"
			@close="resetSlideShow"
		/>
	</div>
</template>

<script>
import GalleryCard from '@/components/GalleryCard/GalleryCard'
import Slideshow from '@/components/Slideshow/Slideshow'
import galleryImagesStructure from '@/mixins/galleryImagesStructure'

export default {
	name: 'GalleryPage',
	mixins: [ galleryImagesStructure ],
	components: {
		GalleryCard,
		Slideshow
	},
	data() {
		return {
			images: [],
			index: null,
			slideshowActive: false
		}
	},
	methods: {
		setSlideshow(images) {
			this.images = images
			this.slideshowActive = true
		},
		resetSlideShow() {
			this.images = []
			this.slideshowActive = false
		}
	}
}
</script>

<style lang="scss" scoped>

.GalleryPage {
	padding-top: 80px;
	position: relative;

	&__header {
		padding: 20px 0;
		background: $blue;
		text-align: center;

		h2 {
			margin: 0;
			text-transform: uppercase;
			color: #FFF;
		}
	}

	&__cards {
		padding: 20px;
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: auto;
		justify-items: center;
		align-items: center;
		grid-gap: 20px;

		@media screen and (min-width: 768px) {
			grid-template-columns: repeat(2, 1fr);
		}

		@media screen and (min-width: 1024px) {
			grid-template-columns: repeat(3, 1fr);
			width: 80%;
			margin: 0 auto;
		}
	}

}

.slideshowActive {
	.GalleryPage__cards {
		overflow: hidden;
		display: none;
		visibility: hidden;
	}
}
</style>
